// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"516":"question","857":"document"}[chunkId] || chunkId) + "." + {"18":"19e68be4","516":"46490a1f","857":"2edc963e"}[chunkId] + ".js";
};